import script from "./DownloadCV.vue?vue&type=script&lang=ts&setup=true"
export * from "./DownloadCV.vue?vue&type=script&lang=ts&setup=true"

import "./DownloadCV.vue?vue&type=style&index=0&id=123fe6b9&lang=css"

const __exports__ = script;

export default __exports__